// extracted by mini-css-extract-plugin
export default {"send_part":"send_send_part__+4CPm","send":"send_send__WblY-"};